import axios from 'axios'

const instance = axios.create({
  baseURL:
    process.env.REACT_APP_API_URL || 'https://api.dealstreetjournal.com/api',
  withCredentials: true, // Critical for cookies to be sent with requests
  headers: {
    'Content-Type': 'application/json',
  },
})

// for localhost
// const instance = axios.create({
//   baseURL: 'http://localhost:8081/api',
//   withCredentials: true,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// })

// const instance = axios.create({
//   baseURL: 'http://localhost:8081/api',
//   headers: {
//     Cookie:
//       'token=eyJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoiU1VQRVJfQURNSU4iLCJhZG1pbklkIjo3LCJmdWxsTmFtZSI6IlN1cGVyIEFkbWluIiwic3ViIjoic3VwcG9ydEBkZWFsc3RyZWV0am91cm5hbC5jb20iLCJpYXQiOjE3NzY1MDU4NzgsImV4cCI6MTc3NjU5MjI3OH0.sWkbrUBo7ldfQIauDs_kAW5c1F95r1c3tAk7uIEtuoc',
//   },
// })

// Request interceptor
// instance.interceptors.request.use(
//   (config) => {
//     // Log outgoing requests (useful for debugging)
//     console.log(`${config.method.toUpperCase()} ${config.url}`)

//     // Add any additional request handling here
//     return config
//   },
//   (error) => {
//     return Promise.reject(error)
//   }
// )

// Response interceptor
// instance.interceptors.response.use(
//   (response) => {
//     // Handle successful responses
//     return response
//   },
//   (error) => {
//     // Handle auth errors (unauthorized or forbidden)
//     if (error.response) {
//       console.log(
//         `Error: ${error.response.status} - ${error.response.statusText}`
//       )

//       if (error.response.status === 401 || error.response.status === 403) {
//         console.log('Authentication error detected, logging out...')
//         // Clear local storage on auth errors
//         localStorage.removeItem('admin')

//         // Could redirect to login here if needed
//         // window.location.href = '/login';
//       }
//     } else if (error.request) {
//       // Request was made but no response received
//       console.log('Network error - no response received')
//     } else {
//       // Something happened in setting up the request
//       console.log('Error setting up request:', error.message)
//     }

//     return Promise.reject(error)
//   }
// )

export default instance
